<template>
  <div v-if="result.amount && result.amount > 0" class="get-today-list-store">
    <div class="get-today-list-store__inform">
      <p class="get-today-list-store__address">
        {{ result.address }}
      </p>
      <div class="get-today-list-store__works">
        <p class="get-today-list-store__time">
          <svg class="get-today-list-store__icon">
            <use xlink:href="#svg-clock-arrow"></use>
          </svg>
          {{ result.schedule }}
        </p>
        <p class="get-today-list-store__phone">
          <svg class="get-today-list-store__icon">
            <use xlink:href="#svg-phone"></use>
          </svg>
          {{ result.phone }}
        </p>
      </div>
    </div>
    <p class="get-today-list-store__status">
      {{ messages.inStock }}
    </p>
    <div class="get-today-list-store__button">
      <DefButtonPrimary @click="$emit('reserve', result)">
        {{ messages.reserve }}
      </DefButtonPrimary>
    </div>
  </div>
</template>

<script>
import DefButtonPrimary from '@components/Def/DefButtonPrimary/DefButtonPrimary.vue';

export default {
  name: 'GetTodayListStore',
  components: { DefButtonPrimary },
  props: ['result', 'messages'],
};
</script>

<style lang="scss" scoped>
.get-today-list-store {
  display: grid;
  align-items: center;
  grid-template-columns: 1fr;
  padding: 16px;
  border: 1px solid var(--border-grey);
  grid-row-gap: 12px;
  @include point-md {
    grid-template-columns: 1.5fr 1fr;
  }
  @include point-lg {
    grid-template-columns: 2fr repeat(2, 0.6fr);
    grid-auto-flow: column;
    grid-column-gap: 24px;
  }
  &__button {
    @include point-md {
      order: 2;
      grid-row-start: 1;
      grid-row-end: 3;
      grid-column-start: 2;
      grid-column-end: 3;
      justify-self: self-end;
    }
    @include point-lg {
      order: 3;
      grid-row-end: 2;
      grid-column-start: 3;
      grid-column-end: 4;
    }
  }
  &__status {
    display: flex;
    align-items: center;
    gap: 7px;
    font-size: 12px;
    font-weight: 600;
    line-height: 125%;
    text-transform: uppercase;
    color: var(--color-green);
    &:before {
      content: '';
      display: inline-block;
      width: 5px;
      height: 5px;
      background-color: currentColor;
      border-radius: 50%;
    }
    @include point-md {
      order: 3;
    }
    @include point-lg {
      order: 2;
    }
  }
  &__inform {
    //order: 1;
  }
  &__address {
    color: var(--color-main);
    font-size: 16px;
    font-weight: 600;
    line-height: 125%;
    margin-bottom: 12px;
    @include point-md {
      font-size: 18px;
    }
  }
  &__works {
    @include point-md {
      display: flex;
      gap: 24px;
    }
  }
  &__phone,
  &__time {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    font-weight: 500;
    line-height: 125%;
    color: #3f3f44;
  }
  &__time {
    margin-bottom: 8px;
    @include point-md {
      margin-bottom: 0;
    }
  }
  &__icon {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
  }
  :deep(.def-button-primary),
  :deep(.def-button-secondary) {
    width: 100%;
    @include point-md {
      width: auto;
      min-width: 164px;
    }
  }
}
</style>
